import React, { useEffect } from 'react';
import Nav from './components/nav/Nav';
import Footer from './components/footer/Footer';
import Home from './pages/Home';
import ThemeToggle from './components/common/ThemeToggle';
import portfolioConfig from './config/portfolioConfig';

const App = () => {
  useEffect(() => {
    document.title = portfolioConfig.site.title;
  }, []);

  return (
    <div className="app-shell">
      <ThemeToggle />
      <Nav />
      <main>
        <Home />
      </main>
      <Footer />
    </div>
  );
};

export default App;
